<form class="password-parametrization__form" [formGroup]="passwordEntries" (ngSubmit)="onSubmit()">
  <div class="mb-5">
    <div class="row mb-2">
      <div class="col col-md-6">
        <label class="mr-inter-text-med d-block" for="numbersOfAttemps">Número de intentos</label>
        <mat-form-field class="d-block" appearance="outline">
          <input id="numbersOfAttemps" type="number" formControlName="numbersOfAttemps" min="0" matInput>
        </mat-form-field>
      </div>
      <div class="col col-md-6">
        <label class="mr-inter-text-med d-block" for="waiting-time">Tiempo de espera (bloqueo temporal)</label>
        <mat-form-field class="d-block" appearance="outline">
          <input id="waiting-time" type="number" formControlName="waitingTime" min="0" matInput>
          <mat-hint align="start">
            <small>Se tomará el tiempo de espera en minutos</small>
          </mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col col-md-6">
        <label class="mr-inter-text-med d-block" for="numbersOfCycles">Cantidad de ciclos permitidos</label>
        <mat-form-field class="d-block" appearance="outline">
          <input id="numbersOfCycles" type="number" formControlName="numbersOfCycles" min="0" matInput>
          <mat-hint align="start">
            <small>Antes del bloqueo definitivo</small>
          </mat-hint>
        </mat-form-field>
      </div>
      <div class="col col-md-6">
        <label class="mr-inter-text-med d-block" for="passwordRenewalFrequency">Frecuencia para el cambio de
          contraseña</label>
        <mat-form-field class="d-block" appearance="outline">
          <input id="passwordRenewalFrequency" type="number" formControlName="passwordRenewalFrequency" min="0"
            matInput>
          <mat-hint align="start">
            <small>Se tomará la frecuencia en días naturales</small>
          </mat-hint>
        </mat-form-field>
      </div>
    </div>
  </div>


  <div class="col mb-4">
    <label class="mr-inter-text-med d-block" for="url-validity">Vigencia de la URL</label>
    <mat-form-field class="d-block" appearance="outline">
      <input id="url-validity" type="number" formControlName="urlValidation" min="0" matInput>
      <mat-hint align="start">
        <small>Se tomará la duración de la vigencia de la URL en minutos</small>
      </mat-hint>
    </mat-form-field>
  </div>
  <div class="row">
    <div class="col col-md-6">
      <label class="mr-inter-text-med d-block" for="max-attempts">Mensaje para máximos intentos alcanzados</label>
      <mat-form-field class="d-block" appearance="outline">
        <textarea id="max-attemps" formControlName="maxAttempsMesage" matInput></textarea>
      </mat-form-field>
    </div>
    <div class="col col-md-6">
      <label class="mr-inter-text-med d-block" for="blocked-user-message">Mensaje para usuario bloqueado</label>
      <mat-form-field class="d-block" appearance="outline">
        <textarea id="blocked-user-message" formControlName="blockedUserMessage" matInput></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col col-md-6">
      <label class="mr-inter-text-med d-block" for="logged-user-message">Mensaje para usuario logueado</label>
      <mat-form-field class="d-block" appearance="outline">
        <textarea id="logged-user-message" matInput formControlName="loggedUserMessage"></textarea>
      </mat-form-field>
    </div>
    <div class="col col-md-6">
      <label class="mr-inter-text-med d-block" for="unauthorized-user-message">Mensaje para usuario no
        encontrado</label>
      <mat-form-field class="d-block" appearance="outline">
        <textarea id="unauthorized-user-message" formControlName="unauthorizedUserMessage" matInput></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label class="mr-inter-text-med d-block" for="password-recovery-instructions">Instrucciones para recuperación
        contraseña</label>
      <mat-form-field class="d-block" appearance="outline">
        <textarea id="password-recovery-instructions" class="text-area__instructions" rows="1000"
          formControlName="passwordRecoveryInstructions" matInput></textarea>
      </mat-form-field>
    </div>
  </div>
  <div class="row d-flex justify-content-end">
    <div class="col">
      <button type="submit" class="mr-button-border-blue d-block" mat-button>
        Guardar
      </button>
    </div>
  </div>
  <motor-calculo-mensaje-bitacora [idAgente]="agentID()" [nombreAgente]="agentName()" [perfilAgente]="agentProfile()"
    [fechaRegistro]="logDate()"></motor-calculo-mensaje-bitacora>
</form>
